import { Icon, Logo } from 'lidya-common-components';
import React from 'react';
import { Trans } from 'gatsby-plugin-react-i18next';
import './combining.less';

const Combining = () => (
  <div className="o-investors">
    <div className="m-globalContentContainer">
      <div className="m-investors__container">
        <div className="m-investors__banner m-investors__combinig --padding --gray">
          <h2 className="m-investors__text__brand_2_bigger -color-brand -centered">
            <Trans i18nKey="web.ivestors.invest.combining.title" />
          </h2>
          <div className="m-investors__banner m-investors__centered">
            <div className="m-investors__text --box">
              <Icon name="client" className="a-investors__combinig__icon" />
              <h2 className="m-investors__text__title --no-border">
                <Trans i18nKey="web.ivestors.invest.combining.good.client" />
              </h2>
              <p className="m-investors__text__brand_normal">
                <Trans i18nKey="web.ivestors.invest.combining.fast" />
              </p>
            </div>
            <div className="m-investors__text --box">
              <Logo className="a-investors__combinig__icon" />
              <h2 className="m-investors__text__title --no-border">
                <Trans i18nKey="web.ivestors.invest.combining.good.lidya" />
              </h2>
              <p className="m-investors__text__brand_normal">
                <Trans i18nKey="web.ivestors.invest.combining.process" />
              </p>
            </div>
            <div className="m-investors__text --box">
              <Icon name="loans-menu" className="a-investors__combinig__icon" />
              <h2 className="m-investors__text__title --no-border">
                <Trans i18nKey="web.ivestors.invest.combining.good.investors" />
              </h2>
              <p className="m-investors__text__brand_normal">
                <Trans i18nKey="web.ivestors.invest.combining.credit" />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Combining;
